<template>
  <div class="LKPublicationsView">
    <LkBackLink
      :to="backRoute"
      class="LKPublicationsView__back"
    />

    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <div
      v-else-if="single"
      class="LKPublicationsView__content"
    >
      <LKPublicationsCard
        :data="single"
        :topic-slug="topic_slug"
        :get-publication="() => single"
        active
        actionless
        @storage-files-filter-change="onStorageFilesFilterChange"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved, import/extensions */
/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { lkMapper } from '@/store/modules/lk'
import { LkTopicPublicationModel as Model } from './Model'
import {
  lkPublicationsStoreModule as StoreModule,
  lkPublicationsMapper as StoreMapper,
} from './store'

import LkBackLink from '@/components/lk/LkBackLink.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKPublicationsCard from './components/LKPublicationsCard/LKPublicationsCard.vue'
import { LK_PUBLICATIONS_ROUTES } from './utils'

const mixinOptions = { Model, StoreModule }
const viewMixin = createViewMixin(mixinOptions)


export default {
  name: 'LKPublicationsView',
  components: {
    LkBackLink,
    LKProgressCircular,
    LKPublicationsCard,
  },
  mixins: [viewMixin],
  props: {
    topic_slug: {
      type: String,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  data: (vm) => ({
    disabledPaginationQuery: true,
    defaultParams: {
      topic_slug: vm.topic_slug,
    },
  }),
  computed: {
    ...lkMapper.mapState(['topics']),

    getOne() {
      // не удалять, это подмена getOne
      const options = { slug: this.slug }
      return () => this.getOneBySlug(options)
        .then(this.tryRedirectToView)
    },
    backRoute() {
      const topic_slug = (
        this.topic_slug
        || this.data?.topics?.[0].slug
        || this.topics[0].slug
      )

      return {
        name: LK_PUBLICATIONS_ROUTES.LIST,
        params: {
          topic_slug,
        },
      }
    },
  },
  watch: {
    slug() {
      this.asyncData()
    },
  },
  activated() {
    // когда created, то isLoadingAsyncData === true
    if (this.isLoadingAsyncData) return
    this.asyncData(true)
  },
  methods: {
    ...StoreMapper.mapMutations(['updatePublicationStorageFiles']),
    ...StoreMapper.mapActions(['getOneBySlug', 'getStorageFiles']),

    tryRedirectToView(data) {
      let topic_slug
      if (Array.isArray(data?.topics) && data.topics.length > 0) {
        topic_slug = data.topics[0].slug
      } else {
        topic_slug = this.topic_slug
      }

      if (this.topic_slug || !topic_slug) return

      const location = {
        name: LK_PUBLICATIONS_ROUTES.VIEW,
        params: {
          ...this.$route.params,
          topic_slug,
        },
      }

      this.$router.replace(location)
    },
    async onStorageFilesFilterChange({ storage, filters }, callback) {
      const publication = this.single

      const unwatch = callback?.()
      const response = await this.getStorageFiles({
        publicationId: publication.id,
        storageId: storage.id,
        params: filters,
      }).finally(() => unwatch?.())

      if (!response) return

      this.updatePublicationStorageFiles({
        storage,
        files: response.files || response.data,
        count: response.count,
        search_filename: filters.search_filename,
      })
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsView {
  &__back {
    margin-bottom: 10px;
  }

  &__content {
    font-size: 16px;
  }
}
</style>
